import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SERVICE_DELETE_URL } from "api/Service";

export const useDeletePracticeService = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (id: number) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.delete(`${tenantVal}${PRACTICE_SERVICE_DELETE_URL}`, {
        data: { id, tenant: tenantVal },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["practiceServicesAll"] });
    },
  });
};
